<template>
    <div>
        <el-row type="flex" class="mb-10" justify="space-between">
            <!-- Evidence标题 -->
            <el-col :span="20" class="breadcrumb">
                <p class="dark">
                    <el-tag type="success" color="white" v-if="role !== 'student' ">{{!studentName ? '' : studentName}}</el-tag>
                    {{title}}
                </p>
            </el-col>

            <el-col :span="4">
                <!--面包屑-->
                <el-breadcrumb separator="/" class="right breadcrumb">
                    <el-breadcrumb-item :to="this.$route.query.reportIndex + ((role === 'teacher' || role === 'ta') ? '?studentId=' + studentId : '')">{{reportName}}</el-breadcrumb-item>
                    <el-breadcrumb-item>Evidence</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <!--必填evidence提示-->
        <div class="mb-10 p-10 bg-lightgary">
            <h4 class="mb-10">{{skillAbbr}} - {{pageName}} - Evidence Checklist</h4>
            <p>每条证据请以PDF的格式上传，并在Description中简要描述该证据是什么。</p>
            <!--IOLP PRL-->
            <table v-if="(skillAbbr === 'IOLP' && pageName ==='Preparation/Plan') || (skillAbbr === 'PRL' && pageName ==='Preparation')">
                <tr>
                    <td>Mandatory Evidence: <span>1. Action Plan(You can download Action Plan Template below);</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>1.个人行动计划（系统中有模板可下载：Action Plan Template）；</span></td>
                </tr>
            </table>
            <table v-else-if="pageName ==='Do' && (skillAbbr === 'PRL' || skillAbbr === 'IOLP')">
                <tr>
                    <td>Mandatory Evidence: <span>1. Revised Action Plan; </span><span>2. Time management Evidence</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>1. 修改后的个人行动计划；</span><span>2. 时间管理的证据，比如时间表，时间管理软件截屏等。</span></td>
                </tr>
            </table>
            <table v-else-if="pageName ==='Review' && (skillAbbr === 'PRL' || skillAbbr === 'IOLP')">
                <tr>
                    <td>Mandatory Evidence: <span>Result of each target</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>根据Plan部分的measurement确定的三个SMART Target完成结果的证据（每个目标至少1个），比如有资格的成人的反馈（如老师，教练，父母等，<span>不可以是同学或朋友的反馈</span>），成绩单等。</span></td>
                </tr>
            </table>

            <!--PS TP-->
            <table v-else-if="pageName ==='Explore' && (skillAbbr === 'PS' || skillAbbr === 'TP')">
                <tr>
                    <td>Mandatory Evidence: <span>Evidence of finding three options; </span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>展示如何发现问题解决方案的证据，比如展示思考解决方案过程的思维导图（mind map），与别人讨论解决方案的记录（培训中使用的interview sheets），上网搜索解决方案的截屏或等。 </span></td>
                </tr>
            </table>
            <table v-else-if="pageName ==='Plan/Do' && (skillAbbr === 'PS' || skillAbbr === 'TP')">
                <tr>
                    <td>Mandatory Evidence: <span>1. Action Plan;</span> <span>2. Evidence showing process of problem solving.</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>1.个人行动计划</span><span>2.展示三个sub-problem解决过程的证据，比如记录解决过程的视频，音频，照片，笔记等。 </span></td>
                </tr>
            </table>
            <table v-else-if="pageName ==='Review' && (skillAbbr === 'PS' || skillAbbr === 'TP')">
                <tr>
                    <td>Mandatory Evidence: <span>Result of each sub-problem</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>根据Plan部分制定的checking method确定的三个sub-problem解决结果的证据（每个sub-problem至少1个），比如有资格的成人给你的反馈（如老师，教练，父母等，<span>不可以是同学或朋友的反馈</span>），评分表结果等。</span></td>
                </tr>
            </table>

            <!--R RS-->
            <table v-else-if="pageName ==='Planning' && (skillAbbr === 'R' || skillAbbr === 'RS')">
                <tr>
                    <td>Mandatory Evidence: <span>Action Plan(You can download Action Plan Template below)</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>个人行动计划（系统中有模板可下载：Action Plan Template）</span></td>
                </tr>
            </table>
            <table v-else-if="pageName ==='Carrying out the research' && (skillAbbr === 'R' || skillAbbr === 'RS')">
                <tr>
                    <td>Mandatory Evidence: <span>1. Evidence of Secondary Research; </span><span>2. Evidence of Primary Research.</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>1.展示二手调研过程的证据，如网页截屏，网页链接，读书笔记，查阅资料的整理等；</span><span>2.展示一手调研过程的证据，如采访照片，采访稿，调查问卷，实地考察的照片等。一共要提供使用至少三种不同调研方式的证据。</span></td>
                </tr>
            </table>
            <table v-else-if="pageName ==='Presentation' && (skillAbbr === 'R' || skillAbbr === 'RS')">
                <tr>
                    <td>Mandatory Evidence: <span>1. Evidence showing information analysis; </span><span>2. Research Paper (800 English words); </span><span>3. PPT; </span><span>4. Feedback from others (tutors, parents and other qualified adults) to your research findings.</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>1.展示对搜集到的信息进行分析的证据，如问卷调查结果的统计和分析图表，采访结果的整理和分析笔记等；</span><span>2.调研报告（不少于800英文单词）；</span><span>3.PPT；</span><span>4.别人对你调研结果，如调研报告，PPT和分析图表等的反馈，必须是有资格的成年人，如老师等的反馈。</span></td>
                </tr>
            </table>

            <!--WWO TW-->
            <table v-else-if="(skillAbbr === 'WWO' && pageName ==='Preparation/Plan') || (skillAbbr === 'TW' && pageName ==='Preparation')">
                <tr>
                    <td>Mandatory Evidence:<span>1. Team Action Plan(You can download Team Action Plan Template below); </span><span>2. Personal Action Plan(You can download Personal Action Plan Template below); </span><span>3. First Team Meeting Minute; </span><span>4. First Team Meeting Photos.</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>1.团队行动计划（系统中有模板可下载：Team Action Plan Template），每个团队一份；</span><span>2.个人根据自己的分工制定的个人行动计划（系统中有模板可下载：Personal Action Plan Template）；</span><span>3.第一次团队会议记录；</span><span>4.第一次团队会议照片。</span></td>
                </tr>
            </table>
            <table v-else-if="pageName ==='Do' && (skillAbbr === 'WWO' || skillAbbr === 'TW')">
                <tr>
                    <td>Mandatory Evidence: <span>1. Evidence of carrying out personal action plan; </span><span>2. Evidence showing personal contribution to the team; </span><span>3.Second Team Meeting Minute; </span><span>4. Second Team Meeting Photos.</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>1.个人完成根据自己分工制定的个人行动计划的证据，比如负责财务管理的同学，需要提供财务预算表，每一笔开支的记录，查找并选择省钱的出行或就餐方案的网页截屏，每一笔花销的收据，制定的决算表等；</span><span>2.个人对团队贡献的证据，比如帮助解决团队分歧的证据，帮助团队成员完成任务的证据，充分利用团队时间的证据等；</span><span>3. 第二次团队会议记录；</span><span>4.第二次团队会议照片。</span></td>
                </tr>
            </table>
            <table v-else-if="pageName ==='Review' && (skillAbbr === 'WWO' || skillAbbr === 'TW')">
                <tr>
                    <td>Mandatory Evidence: <span>1. Team Video (at least 4 minutes);</span><span> 2. Peer Statement; </span><span>3. Third Team Meeting Minute and Photos (if any).</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>1.展示团队合作过程的视频（至少4分钟）；</span><span>2.一位团队成员对你团队合作中表现的评价表（系统中有模板可以下载：Peer Statement）</span><span>3.第三次团队会议记录及照片（如有）。</span></td>
                </tr>
            </table>

            <table v-else-if="skillAbbr === 'D'">
                <tr>
                    <td>Mandatory Evidence: <span>1. Prepared materials for the topic to be discussed;</span><span> 2. Photos of discussion; </span><span>3. Notes taken down during discussion; </span><span>4. Observation Checklist from ASDAN tutor;  </span><span>5. Feedback from group members in trial round of discussion.</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>1.为讨论的主题准备的材料，比如上网搜索的相关信息的截屏或链接，查阅的资料的照片或记录的笔记；</span><span>2.小组讨论的照片；</span><span>3.讨论过程中做的笔记的照片；</span><span>4.ASDAN老师对你讨论过程中表现的评价表；</span><span>5.模拟讨论时同学给你的反馈。</span></td>
                </tr>
            </table>

            <table v-else-if="skillAbbr === 'OP'">
                <tr>
                    <td>Mandatory Evidence: <span>1.PPT; </span><span>2.Notes for presentation; </span><span>3.Practice photos or videos; </span><span>4. Other preparations for presentation; </span><span>5.Observation Checklist from ASDAN Tutor; </span><span>6. Feedback from group members in presentation practice.</span></td>
                </tr>
                <tr>
                    <td>必要证据：<span>1.Research技能中做的PPT；</span><span>2.在演讲中给自己提词的笔记，演讲结构纲要等；</span><span>3. 做演讲练习时的照片或视频；</span><span>4.为演讲做的其他准备，比如学习名人演讲所看的网上视频的截屏，在网上查找的演讲技巧的笔记照片等；</span><span>5.ASDAN老师对你演讲过程中表现的评价表；</span><span>6.模拟演讲/演讲练习时同学给你的反馈。</span></td>
                </tr>
            </table>
        </div>

        <!-- 列表 -->
        <el-row>
            <el-col :span="24">
                <el-table :data="evidences" style="width:100%" empty-text="No data" v-loading="isLoading" default-expand-all>
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <!-- 缩略图 -->
                            <ul v-if="scope.row.templateType === 1" class="el-upload-list el-upload-list--picture-card">
                                <li class="el-upload-list__item is-success" v-for="(answer, index) in scope.row.answerList" :key="index"
                                    @click="handlePictureCardPreview(answer)">
                                    <img :src="answer.thumb" alt="" class="el-upload-list__item-thumbnail">
                                    <span class="el-upload-list__item-actions">
                                        <span class="el-upload-list__item-preview">
                                            <i class="el-icon-view"></i>
                                        </span>
                                    </span>
                                </li>
                            </ul>

                            <!-- pdf图标 -->
                            <a v-else-if="scope.row.templateType === 0" :href="answer.url" target="_blank"
                               v-for="answer in scope.row.answerList">
                                <img src="../../assets/pdf_icon.jpg" alt="" class="pdfIcon">
                            </a>
                            <!-- link -->
                            <a v-else-if="scope.row.templateType === 2" :href="tryAddProtocol(scope.row.answerList.length === 0 ? '' : scope.row.answerList)" target="_blank">
                                {{scope.row.answerList.length === 0 ? '' : scope.row.answerList}}
                            </a>
                        </template>

                    </el-table-column>
                    <el-table-column prop="sequence" label="Seq" width="65" align="center">
                    </el-table-column>

                    <el-table-column prop="description" label="Description" min-width="125">
                    </el-table-column>

                    <el-table-column prop="templateType" label="Type" min-width="155" :formatter="getTemplateText">
                    </el-table-column>

                    <el-table-column prop="time" label="CreatedDate" min-width="125">
                    </el-table-column>
                    <el-table-column label="Confirmed" min-width="125">
                        <template slot-scope="scope">
                            <i class="el-icon-success" v-if="scope.row.confirmed" style="color:#67C23A"></i>
                            <i class="el-icon-error" style="color: #F56C6C" v-else></i>
                        </template>
                    </el-table-column>
                    <el-table-column label="Actions" width="180" align="center">
                        <template slot-scope="scope">
                            <!-- 各种ActionPlan -->
                            <!--<el-button-group v-if="[2,3,4].indexOf(scope.row.templateType) > -1">
                                <a :href="templateAddr(scope.row.templateType)" class="white">
                                    <el-button type="success" size="mini" class="p-5">
                                        <i class="icon ion-android-download"></i> Template
                                    </el-button>
                                </a>
                                <el-button type="primary" icon="el-icon-edit" size="mini" class="p-5"
                                           @click="showDialog(scope.row.templateType, scope.$index)">
                                </el-button>
                                <el-button type="success" icon="el-icon-arrow-up" size="mini" class="p-5" @click="handleMoveOrder(-1, scope.row.sequence, scope.row)"
                                           :disabled="scope.$index == 0">
                                </el-button>
                                <el-button type="success" icon="el-icon-arrow-down" size="mini" class="p-5" @click="handleMoveOrder(1, scope.row.sequence, scope.row)"
                                           :disabled="scope.$index == evidences.length - 1">
                                </el-button>
                            </el-button-group>
                            &lt;!&ndash; Witness testimony、 statement，两个OC &ndash;&gt;
                            <el-button-group v-else-if="[0,1,8,9].indexOf(scope.row.templateType) > -1">
                                <el-button type="primary" icon="el-icon-edit" size="mini" class="p-5"
                                           @click="showDialog(scope.row.templateType, scope.$index)">
                                </el-button>
                                <el-button type="success" icon="el-icon-arrow-up" size="mini" class="p-5" @click="handleMoveOrder(-1, scope.row.sequence, scope.row)"
                                           :disabled="scope.$index == 0">
                                </el-button>
                                <el-button type="success" icon="el-icon-arrow-down" size="mini" class="p-5" @click="handleMoveOrder(1, scope.row.sequence, scope.row)"
                                           :disabled="scope.$index == evidences.length - 1">
                                </el-button>
                            </el-button-group>-->
                            <!-- 其他类型 -->
                            <el-button-group>
                                <el-button type="primary" icon="el-icon-edit" size="mini" class="p-5"
                                           @click="showDialog(scope.row.templateType, scope.$index, scope.row.confirmed)">
                                </el-button>
                                <el-button type="danger" icon="el-icon-delete" size="mini" class="p-5"
                                           @click="handleDeleteEvidence(scope.$index, scope.row)">
                                </el-button>

                                <el-button type="success" icon="el-icon-arrow-up" size="mini" class="p-5" @click="handleMoveOrder(-1, scope.row.sequence, scope.row)"
                                           :disabled="scope.$index == 0">
                                </el-button>
                                <el-button type="success" icon="el-icon-arrow-down" size="mini" class="p-5" @click="handleMoveOrder(1, scope.row.sequence, scope.row)"
                                           :disabled="scope.$index == evidences.length - 1">
                                </el-button>

                            </el-button-group>

                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <!-- 增加更多按钮 -->
        <el-row class="mb-50">
            <el-col :span="24">
                <el-dropdown placement="top-start" class="mt-10 mb-10" @command="addEvidence" >
                    <el-button type="primary" >
                        Add more evidence <i class="el-icon-caret-bottom el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu class="evidence-Dropdown" slot="dropdown" v-loading="isBtnClick">
                        <el-dropdown-item command="0">PDF</el-dropdown-item>
                        <!-- <el-dropdown-item command="1">Image</el-dropdown-item> -->
                        <!-- <el-dropdown-item command="2">Video link</el-dropdown-item> -->
                        <el-dropdown-item v-if="(this.skillAbbr ==='TW'&&this.pageName ==='Review')|| (this.skillAbbr ==='WWO'&&this.pageName ==='Review')" command="3">Peer/Witness statement</el-dropdown-item>
                        <el-dropdown-item v-if="this.skillAbbr ==='D'" command="4">Observation checklist</el-dropdown-item>
                        <el-dropdown-item v-if="this.skillAbbr ==='OP'" command="5">Observation checklist</el-dropdown-item>
                        <el-dropdown-item v-if="this.skillAbbr ==='ISP'&&this.pageName ==='Evaluating Presentation'" command="6">Observation checklist</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <a :href="this.templateHref" class="white" v-if="this.templateName!==''">
                    <el-button type="success" >
                        <i class="icon ion-android-download"></i> {{templateName}}
                    </el-button>
                </a>
                <a :href="this.templateHref1" class="white" v-if="this.templateName1!==''">
                    <el-button type="success" >
                        <i class="icon ion-android-download"></i> {{templateName1}}
                    </el-button>
                </a>
                <el-button type="success" plain @click="confirmAll" v-if="role === 'teacher' || role === 'ta'">Confirm All</el-button>
            </el-col>
        </el-row>

        <evidence-dialog
            ref="evidenceDialog"
            :userId="userId"
            :studentId="studentId"
            @saved="getEvidences"
            @confirmed="getEvidences"
            @disapproved="getEvidences"></evidence-dialog>

        <!-- 图片预览对话框 -->
        <el-dialog :visible.sync="picReview" width="90%" customClass="dialogWidth-1000" title="Preview" :modal="true">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <!-- pdf预览 -->
        <a ref="pdfPreview" target="_blank"></a>

    </div>
</template>

<script>
    import util from '../../component/util.js'
    import Cookies from 'js-cookie'
    import EvidenceDialog from '../common/EvidenceDialog.vue'
    const templateTypeDefinition = [
//        'Witness testimony', //0
//        'Peer/Witness statement', //1
//        'Team action plan', //2
//        'Personal action plan', //3
//        'Action plan', //4
//        'PDF', //5
//        'Image', //6
//        'Video link', //7
//        'Observation checklist', //8 COPE-D
//        'Observation checklist'] //9 COPE-OP
        'PDF', //0
        'Image', //1
        'Video link', //2
        'Peer/Witness statement', //3
        'Observation checklist', //4 COPE-D
        'Observation checklist', //5 COPE-OP
        'Observation checklist', //6 AOPE-ISP
    ]
    export default {

        components: {
            'evidence-dialog': EvidenceDialog
        },
        computed: {
            title() {
                return `${this.reportName} - ${this.skillName} - ${this.pageName} - Evidence`;
            }
        },

        data() {
            return {
                userId: '',
                // 路由参数
                studentId: '',
                studentName: '',
                pageId: '',
                skillAbbr: '',
                reportName: '',
                reportId: 0,
                skillName: '',
                pageName: '',
                role: '',

                // 列表数据
                evidences: [],
                isLoading: false,

                dialogImageUrl: '',
                picReview: false,

                isBtnClick:false,

                //evidence 下载模板按钮所用
                templateName:'',
                templateName1:'',
                templateHref:'',
                templateHref1:'',
                //判断是否已经存在了Peer/Witness statement 或 Observation checklist
                isHavingPS:false

            }
        },
        methods: {
            // 列表相关
            getEvidences() {
                this.isLoading = true
                this.$http.get('/pageEvidence', {params: {studentId: this.studentId, pageId: this.pageId}}).then(response => {
                    this.evidences = this.parseEvidences(response)
                    this.isLoading = false
                }).catch(error => {
                    this.isLoading = false
                    this.$message.error(error.message)
                })
            },
            // 解析Evidence，拿出里面复杂的answer数据结构直接放到evidence下
            parseEvidences(rawArray) {
                let results = []
                for (let i = 0; i < rawArray.length; i++) {
                    let raw = rawArray[i]
                    let evi = Object.assign(raw)
                    results.push(evi)

                    let answerList = []
                    if (raw.answerList != undefined && raw.answerList.length > 0) {

                        let first = JSON.parse(raw.answerList[0])
                        // 解析JSON，把里面的answer数组拿出来，直接赋到evidence上
                        if (first.list != undefined) {
                            //TODO: 临时的代码，定下来需求后重构，放到服务器端
                            if (first.list.length > 0) {
                                if (first.list[0].length > 0) {
                                    if (first.list[0][0].type === 'input' || first.list[0][0].type === 'text') {
                                        // 如果有answer，强行取第一条为输入框的answer作为description
                                        evi.description = first.list[0][0].answer
                                    }
                                }
                            }


                            // 循环多条evidenceAnswer记录，找到有图片或pdf的answer
                            for (let l = 1; l < raw.answerList.length; l++) {
                                // 每一条是个JSON
                                let rawAnswers = JSON.parse(raw.answerList[l])
                                // 解析JSON，把里面的answer数组拿出来，直接赋到evidence上
                                if (rawAnswers.list != undefined) {
                                    for (let j = 0; j < rawAnswers.list.length; j++) {
                                        for (let k = 0; k < rawAnswers.list[j].length; k++) {
                                            if (rawAnswers.list[j][k] != undefined) {
                                                if (rawAnswers.list[j][k].type === 'image' || rawAnswers.list[j][k].type === 'pdf' || rawAnswers.list[j][k].type === 'link') {
                                                    answerList = rawAnswers.list[j][k].answer
                                                    if (rawAnswers.list[j][k].type === 'image' && answerList !== '') {
                                                        // answerList.forEach(file => file.url = util.resizeOSSImage.switchResizeToThumbnail(file.url))
                                                    }
                                                    break
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    evi.answerList = answerList
                }
                return results

            },

            getTemplateText(row, colunm){
                return templateTypeDefinition[row.templateType]
            },

            templateAddr(skillAbbr,pageName) {
                let trimPageName = pageName.trim()
                let addr = '';
                let addr1 = '';
                let name = '';
                let name1 = '';
                this.templateName = name
                this.templateName1 = name1
                this.templateHref1 = addr1
                this.templateHref = addr
            },

            confirmAll() {
                this.$http.patch(`pageEvidence/confirmAll?studentId=${this.studentId}&pageId=${this.pageId}`).then(res => {
                    this.evidences.forEach(item => item.confirmed = true)
                    this.$message.success('confirm success')
                }).catch(err => {
                    this.$message.error(err.message)
                })
            },

            // 删除
            handleDeleteEvidence(index, row){
                this.$confirm('Are you sure to delete?', 'Confirm', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning',
                    confirmButtonLoading : false,
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            done();
                        } else {
                            instance.confirmButtonLoading = false;
                            done();
                        }
                    }
                }).then(() => {
                    this.$http.delete('pageEvidence/' + this.evidences[index].id).then(response => {
//                        this.evidences.splice(index, 1)
                        this.getEvidences()
                        this.$message({
                            type: 'success',
                            message: 'Evidence deleted.'
                        })
                    }).catch(error => {
                        this.$message.error(error.message)
                    })
                }).catch(() => {
                    // 用户点了取消删除
                })
            },

            addEvidence: function (templateType) {
                //判断evidence是否已经含有'Peer/Witness statement',//'Observation checklist'
                this.isHavingPS = false
                for(var i = 0; i<this.evidences.length; i++){
                    if(this.evidences[i].templateType ==3 ||this.evidences[i].templateType ==4 ||this.evidences[i].templateType ==5 ||this.evidences[i].templateType ==6){
                        this.isHavingPS = true
                    }
                }

                if(this.isHavingPS && (templateType ==3 || templateType ==4 || templateType ==5 || templateType ==6)){
                    this.$message.warning('You can only add one evidence of this type.')
                }else {
                    var _this = this;
                    _this.isBtnClick = true;
                    var evidence = {report: {id: this.reportId}, page: {id: this.pageId}, templateType: templateType};
                    this.requestApi('pageEvidence', 'post', evidence, function (response) {
                        evidence.id = response.id;
                        evidence.time = response.time;
                        evidence.sequence = _this.evidences.length + 1;
                        _this.evidences.push(evidence)
                        _this.showDialog(templateType, _this.evidences.length - 1, null, true);
                        _this.isBtnClick = false;
                    });
                }
            },

            handleMoveOrder(offset, seq, evidence) {
                this.$http.put('pageEvidence/sequence', {},{params: {evidenceId: evidence.id, sequence: seq + offset}}).then(response => {
//                    this.evidences.splice(seq - 1, 1)
//                    this.evidences.splice(seq - 1 + offset, 0, evidence)

                    this.getEvidences()

                }).catch(error => {
                    this.$message.error(error.message)
                })

            },

            requestApi: function (url, method, params, successFunc) {
                this.$http({
                    method: method,
                    url: url,
                    data: params
                }).then(response => {
                    successFunc(response);
                }).catch(error => {
                    this.$message.error(error.message)
                })
            },


            //处理显示当前templateType的所有逻辑
            showDialog: function (type, index, confirmed, isAdd) {
                this.$refs.evidenceDialog.showEvidenceDialog(type, this.evidences[index].id, null, confirmed, isAdd)

            },

            handlePictureCardPreview(file) {
                console.log('handlePictureCardPreview entered')
                console.log(file)
                this.dialogImageUrl = file.url
                this.picReview = true;
            },
            handlePDFPreview(file) {
                console.log('handlePDFPreview entered')
                console.log(file)

//                this.$refs.pdfPreview.href = URL.createObjectURL(file.raw)
                this.$refs.pdfPreview.href = file.url
                this.$refs.pdfPreview.click()
//                URL.revokeObjectURL(file.raw)
            },

            tryAddProtocol(url){
                url = url.trim()
                if (!/^(ftp|https?|\/|file)/.test(url)) {
                    url = 'http://' + url
                }
                return url
            },

            init() {
                console.log('init')
                this.userId = Cookies.get('userid')
                this.role = Cookies.get('role');

                let query = this.$route.query
                if (query) {
                    this.reportName = query.reportName.toUpperCase()
                    // 不知道为什么赋值了就不好用了，先去掉这个吧
//                    this.reportIndex = query.reportIndex
                    this.pageId = query.pageId
                    this.skillName = query.skillName
                    this.pageName = (query.pageName).replace(/(^\s*)|(\s*$)/g, "");
                    this.skillAbbr = query.skillAbbr
                    this.studentId = query.studentId
                    this.reportId = query.reportId;
                    this.studentName = query.studentName
                } else {
                    this.$message.error('Cannot get evidence')
                }

                this.getEvidences()
            },
        },
        mounted() {
            this.init()
            this.templateAddr(this.skillAbbr,this.pageName)
        },
        watch:{
            '$route': 'init'
        }
    }
</script>


<style lang="scss" scoped>

    @import "../../css/variable";

    .border-hearder {
        border-color: #dfe6ec !important;
        margin-top: -1px;
    }

    .pdfIcon {
        width: 50px;
        height: 50px;
    }

    .evidence-Dropdown {
        width: 192px;
    }

    .bg-lightgary{
        background:  $header-color;
        border: 1px solid #e6e6e6;
        table{
            tr td:first-child{
                //width: 170px;
                display: list-item;
                margin-left: 15px;
                margin-top: 4px;
            }
            td{
                color: #000000;
                span{
                    background: #e6e6e6;
                    display: inline-block;
                    padding: 2px 5px;
                    margin: 2px 10px 0  0 ;
                    color: $theme-color;
                    font-weight: normal!important;
                    span{
                        color: $danger;
                        margin: 0;
                        padding: 0;
                    }
                }
            }
        }
    }
    .p-5{
        padding: 5px;
    }
</style>


// WEBPACK FOOTER //
// Evidence.vue?41f1de3f